import { Component } from '@angular/core';
import { Headline } from '../../shared/components/ui/headline/headline';
import {
  Alignment,
  HTag,
} from '../../shared/components/ui/headline/headline.model';

@Component({
  selector: 'app-not-found',
  imports: [Headline],
  template: `
    <div class="flex flex-col gap-5">
      <app-headline
        [content]="{
          title: 'Oups... mauvaise direction !',
          hTag: hTag.H1,
          headlineAlignment: alignment.Left,
        }"
        [showDivider]="true"
        [showDoubleDivider]="true"
      ></app-headline>
      <p>La page que vous recherchez n'existe pas.</p>
    </div>
  `,
})
export class NotFound {
  readonly hTag = HTag;
  readonly alignment = Alignment;
}
